module.exports = __webpack_public_path__ + "img/ico-education.8fb8a480.svg";